var map = {
	"./centerMatBlack10.png": "./src/assets/img/rubberPuzzle/centerMatBlack10.png",
	"./centerMatBlue10.png": "./src/assets/img/rubberPuzzle/centerMatBlue10.png",
	"./centerMatBlue35.png": "./src/assets/img/rubberPuzzle/centerMatBlue35.png",
	"./centerMatBrick10.png": "./src/assets/img/rubberPuzzle/centerMatBrick10.png",
	"./centerMatBrown95.png": "./src/assets/img/rubberPuzzle/centerMatBrown95.png",
	"./centerMatCharcoalGery95.png": "./src/assets/img/rubberPuzzle/centerMatCharcoalGery95.png",
	"./centerMatGery10.png": "./src/assets/img/rubberPuzzle/centerMatGery10.png",
	"./centerMatGery35.png": "./src/assets/img/rubberPuzzle/centerMatGery35.png",
	"./centerMatGreen35.png": "./src/assets/img/rubberPuzzle/centerMatGreen35.png",
	"./centerMatGrey95.png": "./src/assets/img/rubberPuzzle/centerMatGrey95.png",
	"./centerMatGreyTan95.png": "./src/assets/img/rubberPuzzle/centerMatGreyTan95.png",
	"./centerMatRed35.png": "./src/assets/img/rubberPuzzle/centerMatRed35.png",
	"./centerMatRed95.png": "./src/assets/img/rubberPuzzle/centerMatRed95.png",
	"./centerMatTan10.png": "./src/assets/img/rubberPuzzle/centerMatTan10.png",
	"./centerMatTan35.png": "./src/assets/img/rubberPuzzle/centerMatTan35.png",
	"./centerMatTan95.png": "./src/assets/img/rubberPuzzle/centerMatTan95.png",
	"./centerMat_0.png": "./src/assets/img/rubberPuzzle/centerMat_0.png",
	"./centreMatBlack10.png": "./src/assets/img/rubberPuzzle/centreMatBlack10.png",
	"./cornerMatBlack10.png": "./src/assets/img/rubberPuzzle/cornerMatBlack10.png",
	"./cornerMatBlue10.png": "./src/assets/img/rubberPuzzle/cornerMatBlue10.png",
	"./cornerMatBlue35.png": "./src/assets/img/rubberPuzzle/cornerMatBlue35.png",
	"./cornerMatBrick10.png": "./src/assets/img/rubberPuzzle/cornerMatBrick10.png",
	"./cornerMatBrown95.png": "./src/assets/img/rubberPuzzle/cornerMatBrown95.png",
	"./cornerMatCharcoalGery95.png": "./src/assets/img/rubberPuzzle/cornerMatCharcoalGery95.png",
	"./cornerMatGery10.png": "./src/assets/img/rubberPuzzle/cornerMatGery10.png",
	"./cornerMatGery35.png": "./src/assets/img/rubberPuzzle/cornerMatGery35.png",
	"./cornerMatGery95.png": "./src/assets/img/rubberPuzzle/cornerMatGery95.png",
	"./cornerMatGeryTan95.png": "./src/assets/img/rubberPuzzle/cornerMatGeryTan95.png",
	"./cornerMatGreen35.png": "./src/assets/img/rubberPuzzle/cornerMatGreen35.png",
	"./cornerMatRed35.png": "./src/assets/img/rubberPuzzle/cornerMatRed35.png",
	"./cornerMatRed95.png": "./src/assets/img/rubberPuzzle/cornerMatRed95.png",
	"./cornerMatTan10.png": "./src/assets/img/rubberPuzzle/cornerMatTan10.png",
	"./cornerMatTan35.png": "./src/assets/img/rubberPuzzle/cornerMatTan35.png",
	"./cornerMatTan95.png": "./src/assets/img/rubberPuzzle/cornerMatTan95.png",
	"./cornerMat_0.png": "./src/assets/img/rubberPuzzle/cornerMat_0.png",
	"./sideMatBlack10.png": "./src/assets/img/rubberPuzzle/sideMatBlack10.png",
	"./sideMatBlue10.png": "./src/assets/img/rubberPuzzle/sideMatBlue10.png",
	"./sideMatBlue35.png": "./src/assets/img/rubberPuzzle/sideMatBlue35.png",
	"./sideMatBrick10.png": "./src/assets/img/rubberPuzzle/sideMatBrick10.png",
	"./sideMatBrown95.png": "./src/assets/img/rubberPuzzle/sideMatBrown95.png",
	"./sideMatCharcoalGrey95.png": "./src/assets/img/rubberPuzzle/sideMatCharcoalGrey95.png",
	"./sideMatGery10.png": "./src/assets/img/rubberPuzzle/sideMatGery10.png",
	"./sideMatGery35.png": "./src/assets/img/rubberPuzzle/sideMatGery35.png",
	"./sideMatGreen35.png": "./src/assets/img/rubberPuzzle/sideMatGreen35.png",
	"./sideMatGrey95.png": "./src/assets/img/rubberPuzzle/sideMatGrey95.png",
	"./sideMatGreyTan95.png": "./src/assets/img/rubberPuzzle/sideMatGreyTan95.png",
	"./sideMatRed35.png": "./src/assets/img/rubberPuzzle/sideMatRed35.png",
	"./sideMatRed95.png": "./src/assets/img/rubberPuzzle/sideMatRed95.png",
	"./sideMatTan10.png": "./src/assets/img/rubberPuzzle/sideMatTan10.png",
	"./sideMatTan35.png": "./src/assets/img/rubberPuzzle/sideMatTan35.png",
	"./sideMatTan95.png": "./src/assets/img/rubberPuzzle/sideMatTan95.png",
	"./sideMat_0.png": "./src/assets/img/rubberPuzzle/sideMat_0.png",
	"./squareMatBlack10.png": "./src/assets/img/rubberPuzzle/squareMatBlack10.png",
	"./squareMatBlue10.png": "./src/assets/img/rubberPuzzle/squareMatBlue10.png",
	"./squareMatBlue35.png": "./src/assets/img/rubberPuzzle/squareMatBlue35.png",
	"./squareMatBrick10.png": "./src/assets/img/rubberPuzzle/squareMatBrick10.png",
	"./squareMatBrick35.png": "./src/assets/img/rubberPuzzle/squareMatBrick35.png",
	"./squareMatBrown95.png": "./src/assets/img/rubberPuzzle/squareMatBrown95.png",
	"./squareMatCharcoalGery95.png": "./src/assets/img/rubberPuzzle/squareMatCharcoalGery95.png",
	"./squareMatGreen35.png": "./src/assets/img/rubberPuzzle/squareMatGreen35.png",
	"./squareMatGrey10.png": "./src/assets/img/rubberPuzzle/squareMatGrey10.png",
	"./squareMatGrey35.png": "./src/assets/img/rubberPuzzle/squareMatGrey35.png",
	"./squareMatGrey95.png": "./src/assets/img/rubberPuzzle/squareMatGrey95.png",
	"./squareMatGreyTan95.png": "./src/assets/img/rubberPuzzle/squareMatGreyTan95.png",
	"./squareMatRed95.png": "./src/assets/img/rubberPuzzle/squareMatRed95.png",
	"./squareMatTan10.png": "./src/assets/img/rubberPuzzle/squareMatTan10.png",
	"./squareMatTan35.png": "./src/assets/img/rubberPuzzle/squareMatTan35.png",
	"./squareMatTan95.png": "./src/assets/img/rubberPuzzle/squareMatTan95.png",
	"./squareMat_0.png": "./src/assets/img/rubberPuzzle/squareMat_0.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/rubberPuzzle sync recursive ^\\.\\/.*\\.png$";